import React from 'react';
import EnrolmentFinancialTab from './_tabs/enrolment-financial/tab';
import { PageHeader } from '../../extras/PageLayout';

export default function EnrolmentFinancialPage() {
  return (
    <div>
      <PageHeader title="Enrolment Financial Details" subtitle="View and manage enrollment financial records" />
      <div style={{ padding: '12px 0 24px' }}>
        <EnrolmentFinancialTab />
      </div>
    </div>
  );
}
